import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, BigButton } from "@/components/Field";
import { Panel, AddButton, SelectField, TextArea, Empty } from "@/components/Bits";
import { HIST_TIPOS } from "@/config/equipamentos";
import { useFetch, fmtDate } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";

const MANUAIS = ["manutencao", "revisao", "instalacao", "atualizacao_software", "calibracao", "observacao"];

const AddHist = ({ open, onOpenChange, eq, onSaved }) => {
  const [form, setForm] = useState({ tipo_evento: "manutencao", descricao: "", data: new Date().toISOString().slice(0, 10), horimetro: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/equipamentos/${eq.equipamento_id}/historico`, { ...form, horimetro: form.horimetro === "" ? null : Number(form.horimetro) });
      toast.success("Registro adicionado ao histórico");
      onOpenChange(false);
      setForm({ ...form, descricao: "", horimetro: "" });
      onSaved();
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-3xl" data-testid="hist-form-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Novo registro</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <SelectField label="Tipo" id="h-tipo" value={form.tipo_evento} onChange={(e) => setForm({ ...form, tipo_evento: e.target.value })}
            options={MANUAIS.map((v) => ({ value: v, label: HIST_TIPOS[v] }))} data-testid="hist-form-tipo" />
          <Field label="Data" id="h-data" type="date" value={form.data} onChange={(e) => setForm({ ...form, data: e.target.value })} data-testid="hist-form-data" />
          {eq.tipo === "trator" && <Field label="Horímetro atual (h)" id="h-hor" type="number" step="any" value={form.horimetro} onChange={(e) => setForm({ ...form, horimetro: e.target.value })} data-testid="hist-form-horimetro" />}
          <TextArea label="Descrição *" id="h-desc" required value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} data-testid="hist-form-descricao" />
          <BigButton type="submit" data-testid="hist-form-submit">Salvar registro</BigButton>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export const HistoricoSection = ({ eq, canAdd }) => {
  const { data, reload } = useFetch(`/equipamentos/${eq.equipamento_id}/historico`);
  const [open, setOpen] = useState(false);
  return (
    <Panel title="Histórico do equipamento" testId="equip-historico"
      action={canAdd && <AddButton small onClick={() => setOpen(true)} data-testid="hist-add-button">Registro</AddButton>}>
      {data?.length === 0 && <Empty>Sem registros.</Empty>}
      <ol className="relative border-l-2 border-[#E2DDD3] ml-2 space-y-5">
        {(data || []).map((h) => (
          <li key={h.historico_id} className="pl-5 relative" data-testid={`hist-item-${h.historico_id}`}>
            <span className={`absolute -left-[9px] top-1 h-4 w-4 rounded-full border-2 border-white ${h.tipo_evento === "os" ? "bg-[#C86D51]" : "bg-[#1E4D2B]"}`} />
            <p className="text-xs font-bold uppercase tracking-wider text-[#5C6B66]">{fmtDate(h.data)} · {HIST_TIPOS[h.tipo_evento] || h.tipo_evento}</p>
            {h.os_id ? <Link to={`/ordens-servico/${h.os_id}`} className="font-medium text-[#1E4D2B] hover:underline">{h.descricao}</Link> : <p className="font-medium">{h.descricao}</p>}
            <p className="text-xs text-[#5C6B66]">{h.user_name}{h.horimetro != null ? ` · Horímetro ${h.horimetro} h` : ""}</p>
          </li>
        ))}
      </ol>
      <AddHist open={open} onOpenChange={setOpen} eq={eq} onSaved={reload} />
    </Panel>
  );
};
